import { cms_url, oms_url } from '../../../../shared/config/AppConfig';
import { AttachVehicleFormModel } from '../repo/types/AttachVehicleFormModel';

export function getPartnersCMSUrl(countryCode: string, locale: string): string {
  return (
    cms_url +
    '/api/website-partners-bd?populate[0]=hero_section.banner_img.image&populate[1]=hero_section.know_more_cta.href&populate[2]=hero_section.banner_img_mobile.image&populate[3]=porter_advantage.cards.icon&populate[4]=life_easy_section.icon&populate[5]=additioanal_benifits.cards.icon&populate[6]=testimonial_section.profiles.image&populate[7]=faq_section.faqs.answer&populate[8]=faq_section.toggle_icon.image&populate[9]=download_app.icon&populate[10]=faq_section.toggle_icon.image&populate[11]=partner_own_vehicle.image.image&populate[12]=partner_own_vehicle.action.target&populate[13]=meta_data.faq_schema&populate[14]=get_partner_cta.href' +
    `&locale=${locale}`
  );
}

export function getPartnerVehiclesRequestUrl(geoRegionId: number): string {
  const params = new URLSearchParams({
    geo_region_id: String(geoRegionId),
    with_others: 'true',
  });
  return `${oms_url}/geo_regions/vehicle_details_v2?${params.toString()}`;
}

export function getSubmitVehicleFormUrlAndPayload(
  form: AttachVehicleFormModel,
): { url: string; payload: string } {
  const payload = JSON.stringify({
    vendor_query: {
      name: form.name,
      mobile: form.mobile,
      geo_region_id: form.city.id,
      vehicle_id: form.vehicleType.id,
      info_source: form.infoSource,
      brand: 'porter',
    },
  });
  return { url: `${oms_url}/vendor_contact_us`, payload };
}
